module.exports = __webpack_public_path__ + "static/media/photo147.7c630890.jpg";